module.exports = __webpack_public_path__ + "img/WechatIMG24.d295aeb9.png";